import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
export function useConfig() {
    return useContext(ConfigContext);
}
export const ConfigProvider = ({ config = {}, children }) => {
    return (_jsx(ConfigContext.Provider, { value: Object.assign(Object.assign({}, DEFAULT_CONFIG), config), children: children }));
};
export const CONFIG_ID_ATTRIBUTE = "BXP_CONFIG";
const DEFAULT_CONFIG = {
    environment: "development",
    version: "n/a",
    trelloClientBaseUrl: ""
};
const ConfigContext = createContext(DEFAULT_CONFIG);
//# sourceMappingURL=use-config.js.map